import { restaurantInfoHandler } from "@api/restaurant-api";
import store from "..";
import router from "../../router";
import RestaurantStorage from "../storage/restaurant.storage";
import i18n from '@/helper/i18n'
import { MessageBox, Loading } from 'element-ui';

const restaurant = {
  namespaced: true,
  state: {
    restaurantInfo: RestaurantStorage.restaurantInfo,
    restaurantUUID: RestaurantStorage.restaurantUUID,
    bannerLine : false,
  },
  getters: {
    restaurantUUID(state) {
      return state.restaurantUUID;
    },
    restaurantInfo(state) {
      return state.restaurantInfo;
    },
    bannerLine(state){
      return state.bannerLine;
    }
  },
  mutations: {
    SET_RESTURANT_UUID(state, payload) {
      state.restaurantUUID = payload;
      RestaurantStorage.restaurantUUID = payload;
    },
    SET_RESTAURANT_INFO(state, payload) {
      state.restaurantInfo = payload;
      RestaurantStorage.restaurantInfo = payload;
    },
    SET_BANNER_LINE(state, payload) {
      state.bannerLine = payload;
    },

  },
  actions: {
    setRestaurant: async ({ commit, dispatch }, {restaurantUUID = null , branchUUID = false}) => {
      // fetchUserInfo when switch restaurant
      if (restaurantUUID != RestaurantStorage.restaurantUUID) {
        if (restaurantUUID) {
          commit('SET_RESTURANT_UUID', restaurantUUID);
        }
        if (store.getters['auth/isLoggedIn']) {
          await store.dispatch("user/fetchUserInfo");
        }

        if(branchUUID)
          await store.dispatch("branch/setBranch", branchUUID);
        else
          await store.dispatch("branch/setBranchNull", null);
        
        await dispatch('fetchRestaurantInfo', restaurantUUID)
        
          
      }
      else{
        if(branchUUID)
          await store.dispatch("branch/setBranch", branchUUID);
        else
          await store.dispatch("branch/setBranchNull", null);
      }

      if (!restaurantUUID) {
        throw new Error("Have no restaurant UUID")
      }
    },
    fetchRestaurantInfo: async ({ commit, dispatch }, restaurant_uuid) => {
      const loading = Loading.service({ fullscreen: true });

      const result = await restaurantInfoHandler(restaurant_uuid)
        .then((response) => {
          commit('SET_RESTAURANT_INFO', response.data.data);
          dispatch('changeTheme');
        })
        .catch(async (error) => {
          if (error.response) {
            error = error.toJSON();
          }
          await MessageBox.alert(
            `${i18n.t('store.error-restaurant')}
            <br>${i18n.t('store.try-again-later')}
            <br>${error.message}`,
            i18n.t('store.mistake'),
            { dangerouslyUseHTMLString: true, center: true },
          )
            .catch(() => { });
          await dispatch("fetchRestaurantInfo", restaurant_uuid);
        })
        .finally(() => {
          loading.close();
        });
    },
    changeTheme({ state }) {
      if (!state.restaurantUUID) {
        router.push({ name: "NotFound" });
      }
      function hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        } : null;
      }

      if (RestaurantStorage.restaurantInfo && RestaurantStorage.restaurantInfo.theme) {
        const primaryColor = hexToRgb(RestaurantStorage.restaurantInfo.theme.primary);

        document.documentElement.style.setProperty("--primary-r", primaryColor.r);
        document.documentElement.style.setProperty("--primary-g", primaryColor.g);
        document.documentElement.style.setProperty("--primary-b", primaryColor.b);
        document.documentElement.style.setProperty("--online-order", RestaurantStorage.restaurantInfo.theme.second);
        document.documentElement.style.setProperty("--secondary", RestaurantStorage.restaurantInfo.theme.third);
      }
    },
  }
}

export default restaurant
